// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./" + {"121":"vendor","314":"style"}[chunkId] + ".css";
};